import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Fuel, Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("mhmtkc36@gmail.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      <div className="hidden lg:flex flex-col justify-between w-1/2 relative overflow-hidden p-14">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              "linear-gradient(180deg, rgba(10,13,18,0.55), rgba(10,13,18,0.92)), url('https://images.unsplash.com/photo-1674521645695-815ef207866b?crop=entropy&cs=srgb&fm=jpg&q=85')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <div className="relative flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-[#E65100] flex items-center justify-center">
            <Fuel className="w-6 h-6 text-white" />
          </div>
          <span className="font-display text-xl font-extrabold tracking-tight">İstasyonFinans</span>
        </div>
        <div className="relative">
          <h1 className="font-display text-4xl xl:text-5xl font-black leading-tight tracking-tight">
            Yakıt, kart ve kredi<br />ödemeleriniz<br />
            <span className="text-[#F59E0B]">tek ekranda.</span>
          </h1>
          <p className="text-[#94A3B8] mt-5 max-w-md text-base leading-relaxed">
            Aytemiz alımlarınızın vadesini, ticari kredi kartı hesap kesimlerini ve banka kredi
            taksitlerinizi otomatik ödeme planına dönüştürün.
          </p>
        </div>
        <div className="relative text-[#94A3B8] text-sm">İstasyon işletmecileri için finans kokpiti</div>
      </div>

      <div className="flex-1 flex items-center justify-center p-6 bg-[#0A0D12]">
        <form onSubmit={submit} className="w-full max-w-sm fade-up" data-testid="login-form">
          <div className="lg:hidden flex items-center gap-3 mb-8">
            <div className="w-10 h-10 rounded-xl bg-[#E65100] flex items-center justify-center">
              <Fuel className="w-5 h-5 text-white" />
            </div>
            <span className="font-display text-lg font-extrabold">İstasyonFinans</span>
          </div>
          <h2 className="font-display text-2xl font-bold mb-1">Tekrar hoş geldiniz</h2>
          <p className="text-[#94A3B8] text-sm mb-8">İstasyon panelinize giriş yapın.</p>

          <label className="block text-sm text-[#94A3B8] mb-2">E-posta</label>
          <input
            data-testid="login-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full mb-5 px-4 py-3 rounded-xl bg-[#161D2A] border border-[#253043] focus:border-[#E65100] outline-none transition-colors"
            placeholder="ornek@mail.com"
            required
          />
          <label className="block text-sm text-[#94A3B8] mb-2">Şifre</label>
          <input
            data-testid="login-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full mb-6 px-4 py-3 rounded-xl bg-[#161D2A] border border-[#253043] focus:border-[#E65100] outline-none transition-colors"
            placeholder="••••••••"
            required
          />
          {error && (
            <div data-testid="login-error" className="mb-4 text-sm text-[#EF4444] bg-[#EF4444]/10 border border-[#EF4444]/30 rounded-lg px-3 py-2">
              {error}
            </div>
          )}
          <button
            data-testid="login-submit-button"
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-xl bg-[#E65100] hover:bg-[#F57C00] transition-colors font-semibold flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
            Giriş Yap
          </button>
        </form>
      </div>
    </div>
  );
}
